
import { mapGetters } from 'vuex'

export default {
  name: 'TechnicalFeaturesAccordion',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      groupId: this._uid
    }
  },
  computed: {
    ...mapGetters({
      generalSettings: 'storyblok/settings'
    }),
    technicalFeatures () {
      return this.generalSettings?.technicalFeaturesAccordionBlockContainer?.[0]
    },
    filteredAccordionItems () {
      const accordionItems = this.technicalFeatures?.accordionItems
      if (this.productTechnicalFeatures) {
        const productTechnicalFeatures = Object.values(this.product?.technical_features).map(feature => feature.toLowerCase())
        const filteredItems = accordionItems.filter(item => productTechnicalFeatures.includes(item.title.toLowerCase()))
        return filteredItems
      }
      return []
    },
    productTechnicalFeatures () {
      return this.product?.technical_features
    }
  }
}
